"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SlideToggle = function SlideToggle(_ref) {
  var toggled = _ref.toggled,
      toggleHandler = _ref.toggleHandler;
  return _react["default"].createElement(_styled.ToggleBtnContainer, {
    onClick: toggleHandler,
    toggled: toggled
  }, _react["default"].createElement(_styled.ToggleSlide, {
    toggled: toggled
  }, _react["default"].createElement(_styled.StyledIcon, {
    toggled: toggled,
    icon: "compare",
    width: "100%",
    height: "100%"
  })));
};

var _default = SlideToggle;
exports["default"] = _default;

//# sourceMappingURL=SlideToggle.js.map